import type { FC } from "react";
import { ASSISTANT_AVATAR } from "@/theme/tokens";
import { starPath } from "@/ui/AssistantAvatar/assistantAvatarGeometry";
import { AVATAR_PART } from "@/ui/AssistantAvatar/assistantAvatarMotion";

const { EXTRAS } = ASSISTANT_AVATAR;

const SPARKLES = [
	{ cx: 8, cy: 26, r: 7, fill: EXTRAS.SPARKLE_GOLD },
	{ cx: 112, cy: 30, r: 8, fill: EXTRAS.SPARKLE_GOLD },
	{ cx: 14, cy: 96, r: 5, fill: EXTRAS.SPARKLE_MINT },
	{ cx: 108, cy: 94, r: 6, fill: EXTRAS.SPARKLE_LAVENDER },
] as const;

/** The done burst. Invisible at rest: the done motion pops each one once and leaves them hidden. */
export const AvatarSparkles: FC = () => (
	<g>
		{SPARKLES.map(({ cx, cy, r, fill }) => (
			<path key={cx} className={AVATAR_PART.SPARKLE} d={starPath(cx, cy, r)} fill={fill} />
		))}
	</g>
);
